'use client';

interface ReservationInfoProps {
  reservationNumber: string;
}

export default function ReservationInfo({ reservationNumber }: ReservationInfoProps) {
  return (
    <div className="bg-[#f0f6ff] text-[#1F1F1F] rounded-lg py-6 px-4">
      <div className="flex items-center justify-center gap-2">
        <p className="text-md font-semibold text-[#454545]">예약번호</p>
        <p className="text-md font-semibold text-[#3D8AFF]">{reservationNumber}</p>
      </div>
    </div>
  );
}
